import { KrediKartiHareketleriPage } from './../kredi-karti-hareketleri/kredi-karti-hareketleri';
import { KrediKartiIslemleriPage } from './../kredi-karti-islemleri/kredi-karti-islemleri';
import { KrediKartiOdemeIslemleriPage } from './../kredi-karti-odeme-islemleri/kredi-karti-odeme-islemleri';
 import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Ortak } from './../../../providers/ortak';
import { BankaEkleGuncellePage } from './../banka-ekle-guncelle/banka-ekle-guncelle';
import { Component } from '@angular/core';
import {   NavController, NavParams, ModalController, ActionSheetController } from 'ionic-angular';
 


@Component({
  selector: 'page-bank-liste',
  templateUrl: 'bank-liste.html',
})
export class BankListePage {
  aranan="";
  skip:number=0;
  take:number=50;
  BankaListesi=[];
  aranacaksayfa: number = 0;
  constructor(public navCtrl: NavController,
    public ortak:Ortak,
    public bllOrtak:BllOrtak,
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.kayitAra(null);

 
  }
  kayitAra(e) {

 
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "BankaListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.BankaListesi = sonuc.SonucObject;
 
      
 
    })
  }
  
  bankakayitlari(e) {

    if (e.keyCode == 13) {
      this.kayitAra(this.aranan);

    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(BankaEkleGuncellePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  Bankaduzenle(banka){
    let modal = this.modalCtrl.create(BankaEkleGuncellePage, { BankaVw: banka });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  
  }
  BankaSil(banka) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("Banka_json", banka.ID);
     

      this.bllOrtak.islem(formData, "BankaSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.kayitAra("");
     
    })
   
  }
  BankaHareketleri(banka){
    let modal=this.modalCtrl.create(KrediKartiHareketleriPage,{BankaVw:banka});
    modal.onDidDismiss(data=>{
      this.ionViewDidLoad();
    })
    modal.present();

  }

  KrediKartiIslemleri(banka){
    let modal=this.modalCtrl.create(KrediKartiIslemleriPage,{BankaVw:banka});
 
    modal.onDidDismiss(data=>{
      this.ionViewDidLoad();
    })
    modal.present();

  }
  KrediKartiOdemeIslemleri(banka){
    let modal=this.modalCtrl.create(KrediKartiOdemeIslemleriPage,{BankaVw:banka});
 
    modal.onDidDismiss(data=>{
      this.ionViewDidLoad();
    })
    modal.present();

  }
  Islemler(banka) {
    const actionSheet = this.actionSheetCtrl.create({
      title: 'Banka  İşlemleri',
      buttons: [
        {
          text: 'Kredi Kartı Borcu',
  
          handler:()=>{
        this.KrediKartiIslemleri(banka);
        this.aranacaksayfa=1;
          }
         
        },
        {
          text: 'Kredi Kartı Ödemesi',
  
          handler:()=>{
        this.KrediKartiOdemeIslemleri(banka);
        this.aranacaksayfa=1;
          }
         
        },
        {
          text: 'Hareketler',
  
          handler:()=>{
        this.BankaHareketleri(banka);
          }
         
        },
        // {
        //   text: 'Bankadan Çekilen',
  
        //   handler:()=>{
        //   this.BankayaYatan(banka);
        //   }
         
        // },
        // {
        //   text: 'Havale İşlemi',
  
        //   handler:()=>{
        //   this.BankayaYatan(banka);
        //   }
         
        // },
        // {
        //   text: 'Eft İşlemi',
  
        //   handler:()=>{
        //   this.BankayaYatan(banka);
        //   }
         
        // },
        // {
        //   text: 'Bankalar Arası Virman',
  
        //   handler:()=>{
        //     this.BankayaYatan(banka);
        //   }
         
        // }        ,
        {
          text: 'Düzenle',
          handler: () => {
           this.Bankaduzenle(banka);
          }
        },{
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/BankaIslemleri/bank-liste/bank-liste.ts